module.exports = __webpack_public_path__ + "static/media/python-beginner.1c992568.png";